/* tslint:disable */
/* eslint-disable */
/**
 * Local Map - Local Map Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.3
 * Contact: local-map@daangn.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../../runtime';
/**
 * 
 * @export
 * @interface V1ServiceOpenSurveySection
 */
export interface V1ServiceOpenSurveySection {
    /**
     * 
     * @type {string}
     * @memberof V1ServiceOpenSurveySection
     */
    targetUri: string;
}

/**
 * Check if a given object implements the V1ServiceOpenSurveySection interface.
 */
export function instanceOfV1ServiceOpenSurveySection(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "targetUri" in value;

    return isInstance;
}

export function V1ServiceOpenSurveySectionFromJSON(json: any): V1ServiceOpenSurveySection {
    return V1ServiceOpenSurveySectionFromJSONTyped(json, false);
}

export function V1ServiceOpenSurveySectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1ServiceOpenSurveySection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'targetUri': json['target_uri'],
    };
}

export function V1ServiceOpenSurveySectionToJSON(value?: V1ServiceOpenSurveySection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'target_uri': value.targetUri,
    };
}

